import { render, staticRenderFns } from "./RateWorkouts.vue?vue&type=template&id=70c8c966&scoped=true"
import script from "./RateWorkouts.vue?vue&type=script&lang=js"
export * from "./RateWorkouts.vue?vue&type=script&lang=js"
import style0 from "./RateWorkouts.vue?vue&type=style&index=0&id=70c8c966&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c8c966",
  null
  
)

export default component.exports